import React from 'react'
import { Button } from '@mui/material';
import Image from "../../../../assets/img/default-img.jpg"
import { useSettingContext } from 'context/SettingContext';
import { getIcon } from 'utils/iconsConfig';
import "./syncCardStyle.css"

const SyncCardComp = ({ data, handleClick, handleImage, actionType }) => {
  const { revertPermission } = useSettingContext();
  function ArrayToString(arr) {
    if (arr.length == 0) {
      return "NULL";
    }
    if (actionType == 'collection') {
      return arr.map(item => <li style={{ listStyle: 'none' }} >{item.collectionName},</li>);
    }
    if (data.actionType == 'set') {
      return arr.map(item => `SET-${item.setNumber}`).join(', ') || "NULL";
    }
  }

  return (
    <>
      <div key={data._id} className="card">
        <div className="card-content">
          <div className="header">
            <h4>{data.styleNumber}</h4>
          </div>

          {/* From section */}
          <div className="info-row">
            <span>From :</span>
            <p>
              {actionType === 'set' && ArrayToString(data.currentGatiSetRef)}
              {actionType === 'makeType' && getIcon(data.currentGatiValue)}
              {actionType === 'collection' && ArrayToString(data.currentGatiCollectionRef)}
              {actionType === 'restrict' && (data.currentGatiValue === "true" ? "Restrict" : "Unrestrict")}
              {actionType === 'designClass' && getIcon(data.currentGatiValue?.toLowerCase())}
              {actionType === 'subCategoryName' && data.currentGatiValue}
            </p>
          </div>

          {/* To section */}
          <div className="info-row">
            <span>To :</span>
            <p>
              {actionType === 'set' && ArrayToString(data.currentVisionSetRef)}
              {actionType === 'makeType' && getIcon(data.currentVisionValue)}
              {actionType === 'collection' && ArrayToString(data.currentVisionCollectionRef)}
              {actionType === 'restrict' && (data.currentVisionValue === "true" ? "Restrict" : "Unrestrict")}
              {actionType === 'designClass' && getIcon(data.currentVisionValue?.toLowerCase())}
              {actionType === 'subCategoryName' && data.currentVisionValue}
            </p>
          </div>
        </div>

        <div className="image-container">
          <img
            src={data.transformedImageUrl || Image}
            alt="image"
            onClick={() => handleImage(data)}
          />

          {false ? (
            <Button
              className="revert-button"
              onClick={() => handleClick(data)}
            >
              Revert
            </Button>
          ) : null}
        </div>
      </div>

      {/* Modal section */}

    </>
  )
}

export default SyncCardComp